import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'antd';
import Button from 'components/Button';
import InputText from 'components/InputText';
import InputSelect from 'components/InputSelect';
import DateInterval from 'components/InputDateInterval';
import * as S from './styles';
import { fetchGetTodosStatus } from 'store/fetchActions/fetchInputForm';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import { changeInputFilter } from 'utils/formUtils';
import { fetchSalvarLocalFiltroRequerimentoContribuinte } from 'store/fetchActions/fetchInputForm';
import { TIPO_DOCUMENTO } from 'utils/consts';
import { getFiltroInicial } from 'containers/RequerimentoListar/ListarServicoDuvida';
import moment from 'moment';

export default function FiltroHistoricoRequerimento({ filtroInicial, salvarFiltro, handlePesquisar }) {
  const dispatch = useDispatch();

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const listaStatus = useSelector(state => state.status.todosStatus);
  const configFiltroSalvo = useSelector(state => state.formulario.configFiltroContribuintePesquisa);
  const user = useSelector(state => state.sefaz.userProfile);

  const [isClearDataRequerimento, setIsClearDataRequerimento] = useState(false);
  const [isClearDataEncerramento, setIsClearDataEncerramento] = useState(false);
  const [optionsStatus, setOptionsStatus] = useState([]);
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: getFiltroInicial(filtroInicial),
  });

  React.useEffect(() => {
    if (unitaryTests) return;
    dispatch(fetchGetTodosStatus(listaStatus)).then(resposta => {
      setOptionsStatus(montarDadosInputSelect(resposta, 'id', 'descricao'));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, unitaryTests]);

  React.useEffect(() => {
    if (user?.cpf_cnpj) {
      dispatch(
        fetchSalvarLocalFiltroRequerimentoContribuinte(
          {
            ...configFiltroSalvo?.filtro,
            tipoPessoaId: TIPO_DOCUMENTO[user?.document_type],
            numeroDocumento: user?.cpf_cnpj,
          },
          configFiltroSalvo?.page,
          configFiltroSalvo?.pageSize
        )
      );
      handlePesquisar(
        {
          ...configFiltroSalvo?.filtro,
          tipoPessoaId: TIPO_DOCUMENTO[user?.document_type],
          numeroDocumento: user?.cpf_cnpj,
        },
        configFiltroSalvo?.page,
        configFiltroSalvo?.pageSize
      );
    }

    // eslint-disable-next-line
  }, [dispatch, user]);

  const handleChange = e => {
    changeInputFilter(e, setValue);
  };

  const onSubmit = data => {
    handlePesquisar(data);
  };

  const limparFiltro = () => {
    handlePesquisar({}, 1, 10);
    setIsClearDataEncerramento(true);
    setIsClearDataRequerimento(true);
    setValue('dataAbertura', '');
    setValue('dataEncerramento', '');
    setValue('protocolo', '');
    setValue('statusId', '');
    dispatch(
      fetchSalvarLocalFiltroRequerimentoContribuinte(
        {
          tipoPessoaId: TIPO_DOCUMENTO[user?.document_type],
          numeroDocumento: user?.cpf_cnpj,
        },
        1,
        10
      )
    );
    salvarFiltro({});
  };

  return (
    <form>
      <Row>
        <Col xs={24} sm={16} md={8} lg={8} xl={6}>
          <DateInterval
            label="Data do Requerimento"
            name="dataAbertura"
            control={control}
            defaultValue={
              configFiltroSalvo?.filtro?.dataAbertura?.dataInicio
                ? [
                    moment(configFiltroSalvo?.filtro?.dataAbertura?.dataInicio),
                    moment(configFiltroSalvo?.filtro?.dataAbertura?.dataFim),
                  ]
                : null
            }
            onChange={handleChange}
            isClear={isClearDataRequerimento}
            openChange={() => setIsClearDataRequerimento(false)}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={8} xl={6}>
          <DateInterval
            label="Data do Encerramento"
            name="dataEncerramento"
            control={control}
            defaultValue={
              configFiltroSalvo?.filtro?.dataEncerramento?.dataInicio
                ? [
                    moment(configFiltroSalvo?.filtro?.dataEncerramento?.dataInicio),
                    moment(configFiltroSalvo?.filtro?.dataEncerramento?.dataFim),
                  ]
                : null
            }
            onChange={handleChange}
            isClear={isClearDataEncerramento}
            openChange={() => setIsClearDataEncerramento(false)}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={8} xl={5}>
          <InputText
            label="Protocolo"
            name="protocolo"
            placeholder={'Protocolo'}
            control={control}
            onChange={handleChange}
            maxLength={14}
            errors={errors}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={8} xl={5}>
          <InputSelect
            label="Status"
            name="statusId"
            placeholder={'Status'}
            control={control}
            options={optionsStatus}
          />
        </Col>
        <S.ContainButton>
          <Button text={'Pesquisar'} clickAction={handleSubmit(onSubmit)} />
          <Button text={'Limpar Filtro'} clickAction={() => limparFiltro()} />
        </S.ContainButton>
      </Row>
    </form>
  );
}
